import React, { PropTypes } from 'react';
import classNames from 'classnames';

var linkStyling = {
    padding: '0px 0px 0px 6px'
};

const TacDialog = ({isTacAccepted,  onTacCheckboxChanged, isTacChecked, onTacSubmit}) => (
    <div id="react_tac_card" style={{margin: 9+"%"}} className={classNames('card', 'react_tacCards', {'hidden': isTacAccepted})}>
        <div className="card-header">
            <span><svg className="cyclops-icon" aria-hidden="true"></svg>  Terms and Conditions</span>
        </div>
        <div className="card-block">
            {/*<h5 id="tac_error_msg" className="card-subtitle text-danger">
                <svg className="cyclops-icon danger" aria-hidden="true"></svg> An Error occured while processing your request. Please try again after some time.
            </h5>*/}
            <form id="tac_form">
                <p>Only CenturyLink Cloud administrators are able to accept the terms and conditions. Please click on the box below to accept the terms and conditions before proceeding to the Cloud Integration dashboard.</p>
                <div className="checkbox">
                    <label>
                    <input id="tac_chkbx" type="checkbox" checked={isTacChecked}
                        onChange={(e)=>
         	                {
            	                onTacCheckboxChanged(e.target.checked)
                            }
                        }
                    />I agree to the
                    </label>
                    <a style={linkStyling} href="assets/docs/MCA2015Agr_NA_ENG_Jul2015_PDF.pdf" target="_new">subscription agreement</a>
                </div>
                <button type="button" className={classNames("btn btn-primary btn-block ", {'disabled': !isTacChecked})} onClick={onTacSubmit}>Submit</button>
            </form>
        </div>
        <div className="card-footer"></div>
    </div>
);

TacDialog.propTypes = {
    onTacCheckboxChanged: PropTypes.func.isRequired,
	isTacAccepted: PropTypes.bool.isRequired,
    onTacSubmit: PropTypes.func.isRequired
};

export default TacDialog;


/** WEBPACK FOOTER **
 ** ./src/components/Tac/TacDialog.js
 **/